import { FONT_WEIGHT } from 'Vendor/Utils/Constants';

export const normalizeFontWeight = (value?: string | number) => {
    if (!value) return String(FONT_WEIGHT.REGULAR);

    if (value === 'bold') return String(FONT_WEIGHT.BOLD);
    if (value === 'normal') return String(FONT_WEIGHT.REGULAR);

    return String(value);
};
